import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import { Tactic } from "@/classes";
import TacticDialog from "@/components/tactic/TacticDialog.vue";
import PaginatedTable from "@/components/base/tables/PaginatedTable.vue";
import { FilterDefinition } from "@/types/filter";
import { DataTableHeader } from "@/types/table";
import TacticImport from "@/components/tactic/TacticImport.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'tactics',
  setup(__props) {

const headers: DataTableHeader[] = [
  {
    title: "Maintenance Item",
    key: "maintenance_item",
    sortable: true,
  },
  {
    title: "Maintenance Item Desc.",
    key: "maintenance_item_description",
    sortable: true,
  },
  {
    title: "Func. Loc.",
    key: "functional_location",
    sortable: true,
  },
  {
    title: "Action",
    key: "actions",
    sortable: false,
  },
];

const filterDefinitions: FilterDefinition[] = [
  {
    label: "Maintenance Item",
    value: "maintenance_item",
    type: "string",
  },
  {
    label: "Maintenance Item Desc.",
    value: "maintenance_item_description",
    type: "string",
  },
  {
    label: "Func. Loc.",
    value: "functional_location",
    type: "string",
  },
];

const table = ref<InstanceType<typeof PaginatedTable> | null>(null);
const dialog = ref<InstanceType<typeof TacticDialog> | null>(null);
const importer = ref<InstanceType<typeof TacticImport> | null>(null);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PaginatedTable, {
      ref_key: "table",
      ref: table,
      table: "tactics",
      "table-class": _unref(Tactic),
      "filter-definitions": filterDefinitions,
      headers: headers
    }, {
      "right-actions": _withCtx(() => [
        _createVNode(_component_v_btn, {
          "aria-label": "Import Tactics",
          color: "secondary",
          class: "mr-2",
          flat: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (importer.value.open()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => [
                _createTextVNode("mdi-upload")
              ]),
              _: 1
            }),
            _createTextVNode("Import ")
          ]),
          _: 1
        })
      ]),
      "item.actions": _withCtx(({ item }) => [
        _createVNode(_component_v_btn, {
          "aria-label": "View Tactic",
          view: "View",
          icon: "mdi-eye",
          flat: "",
          density: "compact",
          onClick: ($event: any) => (dialog.value?.open(item.id))
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["table-class"]),
    _createVNode(TacticImport, {
      ref_key: "importer",
      ref: importer,
      onImported: _cache[1] || (_cache[1] = ($event: any) => (table.value?.getData()))
    }, null, 512),
    _createVNode(TacticDialog, {
      ref_key: "dialog",
      ref: dialog,
      onChange: _cache[2] || (_cache[2] = ($event: any) => (table.value?.getData()))
    }, null, 512)
  ]))
}
}

})